import { cva } from 'class-variance-authority';
export const snackbarVariants = cva('pointer-events-auto flex max-w-full items-center rounded-md border border-en-blue-300 bg-en-blue-400 font-medium text-background shadow-lg', {
    variants: {
        dense: {
            true: 'gap-2 px-2.5 py-1.5 text-xs',
            false: 'gap-2.5 px-3 py-2 text-sm',
        },
    },
    defaultVariants: {
        dense: false,
    },
});
export const snackbarIconVariants = cva('flex-none', {
    variants: {
        type: {
            info: 'text-blue-300',
            warning: 'text-amber-400',
            error: 'text-rose-400',
            success: 'text-emerald-400',
            filedownload: 'text-background',
        },
        dense: {
            true: 'size-3.5',
            false: 'size-4',
        },
    },
    defaultVariants: {
        type: 'info',
        dense: false,
    },
});
